<div class="modal-container page-content property">
    <div class="modal-header border-0">
      <h5 class="modal-heading" >Edit Photo Caption</h5>
      <p  class="modal-clost-btn" (click)="bsModalRef?.hide()" aria-label="Close">&times;</p>
    </div>
    <div class="modal-body">
        <div>
            <img [src]="image?.url || defImg" height="300px" class="img-fluild rounded-10" width="100%" alt="img">
        </div>
        <div class="mt-4"> 
            <div class="form-section visible mt-0 p-0 mb-3">
                <label class="form-label mt-2">Image Caption <span class="text-danger">*</span> </label>
                <app-input [formGrp]="form" formCtrlName="description" text [label]="'Enter a suitable caption'"></app-input> 
            </div> 
            <app-button (onclick)="save()" [disabled]="form.invalid || loading" primary >
                {{loading ? 'Saving...': 'Save & Close'}}
            </app-button>
        </div>
    </div>
</div>